import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import CデータPrint from '@/components/データ/print/データPrint.vue';
import { PrintConfig, PrintDialogStyle, 償却Option } from '@/components/データ/print/データPrint';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import 分析PlbscfService from '@/classes/service/分析/分析PlbscfService';
import 金融機関借入Service from '@/classes/service/分析計画/金融機関借入Service';
import 役員借入Service from '@/classes/service/分析計画/役員借入Service';
import 法人保有不動産Service from '@/classes/service/分析/法人保有不動産Service';
import 個人保有不動産Service from '@/classes/service/分析/個人保有不動産Service';
import 償却Service from '@/classes/service/分析計画/償却Service';
import 実態BSService from '@/classes/service/分析/実態BSService';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin, 事業所Mixin, 計画書Mixin).extend({
  name: 'P分析',

  components: {
    CデータPrint,
  },

  data(): {
    eフェーズ種別: Eフェーズ種別;
    printDialogStyle: PrintDialogStyle;
    printConfigs: PrintConfig[];
  } {
    const v分析PlbscfService = new 分析PlbscfService(Eフェーズ種別.分析フェーズ);
    const v金融機関借入Service = new 金融機関借入Service(Eフェーズ種別.分析フェーズ);
    const v役員借入Service = new 役員借入Service(Eフェーズ種別.分析フェーズ);
    const v法人保有不動産Service = new 法人保有不動産Service(Eフェーズ種別.分析フェーズ);
    const v個人保有不動産Service = new 個人保有不動産Service(Eフェーズ種別.分析フェーズ);
    const v償却Service = new 償却Service(Eフェーズ種別.分析フェーズ);
    const opt償却不足額: 償却Option = { functionType: '償却不足額' };
    const v実態BSService = new 実態BSService(Eフェーズ種別.分析フェーズ);
    return {
      eフェーズ種別: Eフェーズ種別.分析フェーズ,
      printDialogStyle: {
        width: '600px',
        top: '4vh',
        tableClass: 'bunseki',
      },
      printConfigs: [
        {
          name: '損益計算書',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.損益計算書,
          },
        },
        {
          name: '貸借対照表',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.貸借対照表,
          },
        },
        {
          name: 'CF計算書',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.CF計算書,
          },
        },
        {
          name: '変動損益計算書',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.変動損益,
          },
        },
        {
          name: '運転資金・回転期間実績表',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.運転資金,
          },
        },
        {
          name: 'FCFと債務償還年数実績表',
          service: v分析PlbscfService,
          with勘定科目: true,
          option: {
            plbscfType: PlbscfType.FCF,
          },
        },
        {
          name: '金融機関借入一覧表',
          service: v金融機関借入Service,
        },
        {
          name: '役員借入一覧表',
          service: v役員借入Service,
        },
        {
          name: '法人保有不動産一覧表',
          service: v法人保有不動産Service,
        },
        {
          name: '個人保有不動産一覧表',
          service: v個人保有不動産Service,
        },
        {
          name: '償却不足額確認表',
          service: v償却Service,
          with勘定科目: true,
          option: opt償却不足額,
        },
        {
          name: '実態BS',
          service: v実態BSService,
          with勘定科目: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            保有不動産Service: v法人保有不動産Service,
            償却Service: v償却Service,
          },
        },
      ],
    };
  },
});
